import { TYPE_NEWSLETTER } from "../../constants/page";
import { NEWSLETTERS_LOGO_BASEURL, NEWSLETTER_GENERIC } from "./constants";

/**
 * Extract the logo image from the newsletter config
 * @param {object} config
 * @returns {string | false} The logo image URL as a string or false if not found
 */
export const getLogoImage = (config) => {
    if (!config?.logo_image) return NEWSLETTER_GENERIC.logo;

    if (config?.logo_image?.link) {
        return config.logo_image.link;
    }

    if (config?.logo_image?.filename) {
        return `${NEWSLETTERS_LOGO_BASEURL}/${config.logo_image.filename}`;
    }

    return false;
};

/**
 * Parses newsletter IDs from page sections.
 * @param {Object[]} sections - The array of page section objects.
 * @returns {string[]} - The array containing newsletter IDs.
 */
export const parseNewsletterIdsFromPageSections = (sections) => {
    if (!sections?.length) return [];

    const newsletters = [];

    const checkifPageSectionsContainNewsletterWidget = (content) => {
        if (content?.type === TYPE_NEWSLETTER) {
            if (content?.newsletter) newsletters.push(content.newsletter);
            else if (content?.pageWidget?.metadata?.newsletter) {
                newsletters.push(content.pageWidget.metadata.newsletter);
            }
        }
    };

    sections.forEach(({ main, right }) => {
        main?.content?.forEach(checkifPageSectionsContainNewsletterWidget);
        right?.content?.forEach(checkifPageSectionsContainNewsletterWidget);
    });

    return newsletters.filter(Boolean);
};
